import { IPendencySimulationsRepository } from 'modules/customer/domain/repositories';
import { makeHTTPProvider } from 'shared/infra/providers';

import VectisPendencySimulationsRepository from './implementations/VectisPendencySimulationsRepository';

let instance: IPendencySimulationsRepository | null = null;

export default function makePendencySimulationsRepository() {
  if (!instance) {
    const httpProvider = makeHTTPProvider();

    instance = new VectisPendencySimulationsRepository(httpProvider);
  }

  return instance;
}
